<template>
    <div class="loader-wrapper" v-if="!chartObj.loaded">
      <base-loader></base-loader>
    </div>
    <div v-else class="chart-wrapper">
      <div v-if="chartObj.data.result && chartObj.data.result.length" class="chart-wrapper-render">
        <chart-funnel-render :chart-key="chartKey" :chartOrder="myOrder"></chart-funnel-render>
        <div class="export-menu"
             v-if="chartObj.data.result && chartObj.data.result.length
                 && chartObj.export && chartObj.exportTo && chartObj.exportTo.length">
          <export-chart-menu :chart-obj="chartObj"></export-chart-menu>
        </div>
      </div>
      <div v-else class="headline">{{ translation('chart.no-chart-data') }}</div>
    </div>
</template>

<script>
import { eventBus } from '@/eventBus'
import BaseLoader from '@/components/loaders/BaseLoader'
import ChartFunnelRender from '@/components/charts/ChartFunnelRender'
import ExportChartMenu from '@/components/charts/ExportChartMenu'
import { mapGetters } from 'vuex'
import _ from 'underscore'

export default {
  name: 'ChartFunnel',
  components: {
    BaseLoader,
    ChartFunnelRender,
    ExportChartMenu
  },
  props: {
    chartKey: { type: String, required: true },
    chartOrder: { type: Array, required: false }
  },
  data () {
    return {
      qp: {},
      myOrder: []
    }
  },
  computed: {
    ...mapGetters(['translation']),
    chartObj: {
      get () { return this.$store.getters.getChartByKey(this.chartKey) }
    }
  },
  created () {
    // TODO - move query parameters in AppDashboard and save to Vuex state
    this.qp = this.$route.query
    let dateFrom = Number(this.qp.dateFrom)
    let dateTo = Number(this.qp.dateTo)
    let dateModified = this.qp.dateModified
    this.$log.info('route query:', this.$route.query)
    // @todo handle this on widget level, this is shortcut at the moment
    if (this.qp.funnelOrder && _.isArray(this.qp.funnelOrder)) {
      this.myOrder = this.qp.funnelOrder
    } else if (this.chartOrder && _.isArray(this.chartOrder)) {
      this.myOrder = this.chartOrder
    }

    eventBus.$on('update-dashboard', () => {
      let defaultFilters = this.$store.getters.selectedFiltersGen
      if (dateFrom && dateTo) {
        defaultFilters.date_time = [dateFrom, dateTo]
      }
      this.$store.dispatch('fetchChartData', {
        key: this.chartObj.key,
        filters: defaultFilters,
        withoutCount: true,
        dateModified: dateModified
      })
    })
  },
  destroyed () {
    eventBus.$off('update-dashboard')
  },
  methods: {
    openDialog (chartType, objectKey) {
      let dialogData = {
        chartType: chartType,
        objectKey: objectKey
      }
      this.$emit('open-dialog', dialogData)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .loader-wrapper {
    position: relative;
    height: 50px;
  }
  .chart-wrapper {
    height: 100%;
  }
  .chart-wrapper-render {
    height: 100%;
  }
  .export-menu {
    position: absolute;
    bottom: 0;
    right: 0;
  }
</style>
